<template>
  <div class="tripAdvisor-preview">
    <img
      class="tripAdvisor-preview__image"
      :src="`https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${rating.toFixed(1)}-MCID-5.svg`"
      width="80.325"
      height="13.5"
      alt=""
    />
    <span class="tripAdvisor-preview__text">{{
      translate('rdReviews', reviewCount, reviewCount)
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'TripAdvisorPreview',
  props: {
    rating: {
      type: Number,
      defaultValue: 0
    },
    reviewCount: {
      type: Number,
      defaultValue: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.tripAdvisor-preview {
  display: flex;
  flex-wrap: nowrap;
  &__image {
    max-width: 80px;
  }
  &__text {
    font-size: 12px;
  }
}
</style>
